export default [
  {
    path: '/handle-control',
    name: 'HandleControl',
    component: resolve =>
      require(['@/views/HandleControl'], resolve)
  },
  {
    path: '/handle/onecode',
    name: 'HandleOnecode',
    component: resolve =>
      require(['@/views/HandleControl/Form/Form'], resolve)
  }
]
